import ComparisonProductLabel from "./ComparisonProductLabel";
import ComparisonRow from "./ComparisonRow";
import ComparisonRowButton from "./ComparisonRowButton";
import React from "react";
import ComparisonRowAddProductButton from "./ComparisonRowAddProductButton";

const ComparisonTable = ({products, translations, addToCart, removeFromComparison, removeFromCart, isSingleChoiceMode}) => {
    return (
        <div className={"wrapper wrapper-products-" + products.length}>
            <div className="product-label">&nbsp;</div>
            {products.map(product => (
                <ComparisonProductLabel translations={translations} key={product.id} product={product}/>
            ))}
            <ComparisonRow property="name" products={products}/>
            <ComparisonRow property="description" products={products}/>
                <ComparisonRow property="price" products={products}
                               valueFormatter={(product) => {
                                       if (Liferay.ThemeDisplay.isSignedIn()) {
                                               return product.price.value;
                                       } else {
                                               return (
                                                   <a onClick={() => window.openSignInModal()}>
                                                       {translations["price.on.request"]}
                                                   </a>
                                               )
                                       }
                               }}/>
                <ComparisonRow property="quality" products={products}/>
                <ComparisonRow
                    valueFormatter={(product) => product.manufacturer.value + " / " + product.model.value + " / " + product.type.value}
                labelFormatter={(product) => product.manufacturer.label + " / " + product.model.label + " / " + product.type.label}
                property="manufacturer" products={products}/>
            <ComparisonRow property="motorCode" products={products}/>
            <ComparisonRow property="doors" products={products}/>
            <ComparisonRow property="location" products={products}/>
            <ComparisonRow property="mileage" products={products}/>
            <ComparisonRow property="year" products={products}/>
            <ComparisonRow property="color" products={products}/>
            <ComparisonRow property="deliveryTime" products={products}/>

            <ComparisonRowAddProductButton label={translations["add-to-cart"]} callback={addToCart} products={products}/>
                {isSingleChoiceMode ?
                    <ComparisonRowButton label={translations["unselect"]} callback={removeFromCart}
                                         cssClassNames="btn btn-secondary" products={products}/>
                    :
                    <ComparisonRowButton label={translations["remove"]} callback={removeFromComparison}
                                         cssClassNames="btn btn-secondary" products={products}/>
                }
        </div>
    )
}

export default ComparisonTable;